import {
  GET_ORDERS_LIST_REQUEST,
  GET_ORDERS_LIST_SUCCESS,
  GET_ORDERS_LIST_FAILURE,
  GET_CURRENT_MONTH_ORDERS_OVERVIEW_REQUEST,
  GET_CURRENT_MONTH_ORDERS_OVERVIEW_SUCCESS,
  GET_CURRENT_MONTH_ORDERS_OVERVIEW_FAILURE,
  GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_REQUEST,
  GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_SUCCESS,
  GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_FAILURE,
} from '../../constants/ActionTypes'
import { ORDER_PER_PAGE } from '../../constants/Constants';
import { OrdersApi } from '../api/OrdersApi';
import moment from 'moment';

/***  GET /orders ***/
const getOrderListRequest = (overwrite) => ({
  type: GET_ORDERS_LIST_REQUEST,
  payload: {
    overwrite: overwrite,
  }
});

const getOrderListSuccess = (data, pageInfo, overwrite) => ({
  type: GET_ORDERS_LIST_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
});

const getOrderListFailure = (error) => ({
  type: GET_ORDERS_LIST_FAILURE,
  payload: {
    error: error
  }
});

export function getOrderList(data = { 'paging': 1, 'page': 1, 'per_page': ORDER_PER_PAGE }, overwrite = true) {
  return async (dispatch) => {
    let query = {
      ...data,
    }

    dispatch(getOrderListRequest(overwrite));

    OrdersApi.getOrders({
      ...query,
    }, dispatch)
      .then((response) => {
        dispatch(getOrderListSuccess(
          response.data.data,
          response.data.meta,
          overwrite
        ));
      })
      .catch((error) => {
        dispatch(getOrderListFailure(error.response));
      });
  };
}

/*** GET /orders/overview ***/
const getCurrentMouthOrdersOverviewRequest = () => ({
  type: GET_CURRENT_MONTH_ORDERS_OVERVIEW_REQUEST,
});

const getCurrentMouthOrdersOverviewSuccess = (data) => ({
  type: GET_CURRENT_MONTH_ORDERS_OVERVIEW_SUCCESS,
  payload: {
    overview: data
  }
});

const getCurrentMouthOrdersOverviewFailure = (error) => ({
  type: GET_CURRENT_MONTH_ORDERS_OVERVIEW_FAILURE,
  payload: {
    error: error
  }
});

export function getCurrentMouthOrdersOverview(data) {
  return async (dispatch) => {
    dispatch(getCurrentMouthOrdersOverviewRequest());
    const currentMonth = moment();
    let query = {
      ...data,
      'created_at_from': currentMonth.startOf('month').format('YYYY-MM-DD'),
      'created_at_to': currentMonth.endOf('month').format('YYYY-MM-DD'),
    }
    OrdersApi.getOrdersOverview(query, dispatch)
      .then((response) => {
        dispatch(getCurrentMouthOrdersOverviewSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getCurrentMouthOrdersOverviewFailure(error.response));
      });
  };
}

/*** GET /orders/overview ***/
const getSelectMouthOrdersOverviewRequest = () => ({
  type: GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_REQUEST,
});

const getSelectMouthOrdersOverviewSuccess = (data) => ({
  type: GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_SUCCESS,
  payload: {
    overview: data
  }
});

const getSelectMouthOrdersOverviewFailure = (error) => ({
  type: GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_FAILURE,
  payload: {
    error: error
  }
});

export function getSelectMouthOrdersOverview(data) {
  return async (dispatch) => {
    dispatch(getSelectMouthOrdersOverviewRequest());

    OrdersApi.getOrdersOverview(data, dispatch)
      .then((response) => {
        dispatch(getSelectMouthOrdersOverviewSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getSelectMouthOrdersOverviewFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/OrderList.js